import './PreloaderCustom.css';
import { useSelector } from 'react-redux';

function PreloaderCustom({newStyle=null, isNewStyleLoader=false, progressVideo=null, fullPreloader=''}) {
    const language = useSelector(state => state.userSlice.language);
    const customizer = useSelector((state) => state.customizer);

    return (
        <div 
            className="loader-wrap" 
            style={newStyle}
        >
            {/* <div className={`loader ${isNewStyleLoader ? 'loader--new-style' : ''} ${!fullPreloader?.length ? customizer.isCollapse ? 'loader--new-style-close' : 'loader--new-style-open' : ''}`}></div> */}
            <div className={`loader ${isNewStyleLoader ? 'loader--new-style' : ''}`}></div>
            {
                progressVideo > 0 &&
                    <div className='loader__progress-wrap'>
                        <div className='loader__progress'>
                            <div>{progressVideo}% Video upload</div>
                            <div></div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default PreloaderCustom;